import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    TextField,
    FormControlLabel,
    Switch,
    styled,
    useTheme
} from '@mui/material';
import { useState, useEffect } from 'react';
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { toast } from 'react-hot-toast';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : theme.palette.common.white,
    }
}));

const MarkAttendanceModal = ({ 
    open, 
    onClose, 
    member, 
    selectedDate, 
    onSuccess,
    chapterMeetingId,
    chapterId,
    startTime
}) => {
    const theme = useTheme();
    const [isPresent, setIsPresent] = useState(member?.is_present || false);
    const [time, setTime] = useState(() => {
        if (member?.time) {
            return member.time.substring(0, 5);
        }
        return startTime;
    });

    useEffect(() => {
        setIsPresent(member?.is_present || false);
        setTime(member?.time ? member.time.substring(0, 5) : startTime);
    }, [member]);

    const handleSubmit = async () => {
        try {
            const payload = {
                chapter_meeting_id: chapterMeetingId,
                chapter: chapterId,
                member: member.id,
                date: selectedDate.toISOString().split('T')[0],
                is_present: isPresent,
                time: isPresent ? `${time}:00` : null
            };

            const response = await apiService.post(API_ENDPOINTS.POST_mark_chapter_attendance, payload);
            
            if (response.success) {
                toast.success('Attendance marked successfully');
                onSuccess();
            } else {
                toast.error('Failed to mark attendance');
            }
        } catch (error) {
            console.error('Error marking attendance:', error);
            toast.error('Failed to mark attendance');
        }
    };

    return (
        <StyledDialog 
            open={open} 
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle sx={{ 
                borderBottom: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
                pb: 2
            }}>
                Mark Attendance
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                    {member?.full_name}
                </Typography>
                {member?.time && (
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Current Status: {member.is_present ? `Present (${member.time})` : 'Absent'}
                    </Typography>
                )}
                <Box sx={{ mt: 2 }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isPresent}
                                onChange={(e) => setIsPresent(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Mark as Present"
                    />
                </Box>
                {isPresent && (
                    <TextField
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        fullWidth
                        sx={{ mt: 2 }}
                        label="Arrival Time"
                        InputLabelProps={{ shrink: true }}
                    />
                )}
            </DialogContent>
            <DialogActions sx={{ 
                p: 2,
                borderTop: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            }}>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained"
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default MarkAttendanceModal;